import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import MyApplicationsTemplate from "../../components/MyApplications";
import * as commonActions from "../../redux/actions/commonAction";
import * as myApplicationsActions from "../../redux/actions/myApplicationsAction";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionComponent";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";
import { setLanguage } from "redux-i18n";
import Sidebar from "../../components/Sidebar";

const MyApplications = (props, context) => {
  const profileReducer = useSelector((state) => state.profileReducer);
  const commonReducer = useSelector((state) => state.commonReducer);
  const myApplicationsReducer = useSelector((state) => state.myApplicationsReducer);

  const dispatch = useDispatch();

  const modalAction = bindActionCreators(modalActions, dispatch);

  const commonAction = bindActionCreators(commonActions, dispatch);
  const myApplicationsAction = bindActionCreators(myApplicationsActions, dispatch);


  const openSetModal = (children) => {
    modalAction.openSetModal(children);
  };

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const onMenuToggle = (isOpen) => {
    commonAction.setIsSideMenuOpen(isOpen);
  };

  const languageChange = (language) => {
    dispatch(setLanguage(language));
  };

  const downloadReport = (fromDate, toDate) => {
    myApplicationsAction.downloadApplicationExcel(fromDate, toDate, profileReducer);
  }

  const getMyApplication = (pageNo, pageSize, searchValue, fromDate, toDate) => {


    let pagination = {
      "pageNo": pageNo ? pageNo : 1,
      "pageSize": pageSize ? pageSize : 10,
      "sortColumn": "",
      "sortOrder": "",
      "searchColumn": "",
      "searchValue": searchValue
    }

    let payload = {
      "fromDate": fromDate,
      "toDate": toDate,
    }

    myApplicationsAction.getMyApplications(payload, pagination, profileReducer?.managersDetails?.companyId);
  }

  return (
    <>
      {window.location.hash !== "#/" && (
        <Sidebar
          languageChange={languageChange}
          openSetModalAction={openSetModal}
          closeRemoveModal={closeRemoveModal}
          managersDetails={profileReducer.managersDetails}
          onMenuToggle={onMenuToggle}
          isSideMenuOpen={commonReducer.isSideMenuOpen}
          context={context}
        />
      )}
      <div className="Content-Panel">
        <ShowForPermission module={PERMISSON_MODULES.MY_APPLICATIONS} permission={PERMISSION_TYPE.VIEW}>
          <MyApplicationsTemplate
            context={context}
            getMyApplication={(pageNo, pageSize, searchVal, fromDate, toDate) => { getMyApplication(pageNo, pageSize, searchVal, fromDate, toDate) }}
            myApplications={myApplicationsReducer.myApplications}
            totalCount={myApplicationsReducer.totalCount}
            downloadReport={downloadReport}
          />
        </ShowForPermission>
      </div>
    </>
  );
};

MyApplications.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default MyApplications;
